<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">{{ props.item.task }}</td>
          <td style="text-align: left">{{ props.item.percentageToDate + ' %' }}</td>
          <td style="text-align: left">{{ dateMixin(props.item.estimatedCompletionDate) }}</td>
          <td style="text-align: left">{{ dateMixin(props.item.actualCompletionDate) }}</td>
          <td style="text-align: left">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "completion-table",
    data() {
      return {
        headers: [
          {
            text: this.$t("vessel.task"),
            align: "start",
            value: "task",
          },
          { text: this.$t("vessel.toDate"), value: "percentageToDate" },
          { text: this.$t("vessel.estDate"), value: "estimatedCompletionDate" },
          { text: this.$t("vessel.actDate"), value: "actualCompletionDate" },
          { text: this.$t("vessel.comments"), value: "comments" },
        ],

        currentMainDprId: null,
        currentPVId: null,
      };
    },
    computed: {
      ...mapGetters([
        "getContext",
        "mv_completion/getCompletionTable",
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
      ]),
      items() {
        return this["mv_completion/getCompletionTable"];
      }
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this["mv_completion/fetchCompletionsByDprId"](this.currentMainDprId);
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_completion/fetchCompletionsByDprId",
      ]),
    },
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
